// How often the client takes a regular withdrawal (SEP-257 item 9).
//
// `regular_withdrawals_frequency` was free text with the placeholder "e.g.
// monthly, quarterly". The firm therefore holds "monthly", "Monthly", "qtrly"
// and "every 3 months" under one id. The question becomes a dropdown over five
// closed values, and this module holds that list.
//
// # What the module claims, and what it does not
//
// The list is the ONE vocabulary. The web schema, the server mirror and the PDF
// fold all read it, and a parity test pins each copy to it.
//
// The module says nothing about a yearly figure. No reader annualised the free
// text before this change, and no reader annualises the closed list now, so an
// annualisation belongs to the slice that first needs one. The form still
// renders an older free-text answer through the "(as recorded)" option of the
// single-select control, so the client's own words stay on the screen.
//
// `Other` is a real option and not an unknown value. The client answers the
// frequency in `regular_withdrawals_frequency_other`, which is free text.

/** The five closed frequency options, in the order the form prints them. */
export const REGULAR_WITHDRAWAL_FREQUENCIES = [
    'Monthly',
    'Quarterly',
    'Half-yearly',
    'Annually',
    'Other',
] as const;

export type RegularWithdrawalFrequency = (typeof REGULAR_WITHDRAWAL_FREQUENCIES)[number];
